<!-- AccordionElement.vue -->

<template>
  <details x-data="{open: !!1, disabled: !!0 }" x-bind:open="open" class="group _accordion open disabled" x-bind:aria-expanded="open" aria-controls="accordion" x-bind:class="{ 'open': open, 'disabled' : 'cursor-default' }" open="open" aria-expanded="true">
    <summary class="_accordion-summary" x-on:click.prevent.stop="if(!disabled) {open = !open}">
      <div v-html="$attrs.head" class="_accordion-title"></div>
    </summary>
    <div class="_accordion-details" x-transition:enter="transition-all duration-300" x-transition:enter-start="opacity-0 max-h-0" x-transition:enter-end="opacity-100 max-h-[9999px]" x-transition:leave="transition-all duration-300" x-transition:leave-start="opacity-100 max-h-[9999px] " x-transition:leave-end="opacity-0 max-h-0">
      
      <component :is="elementLayout" :multiple="true" ref="container" :aria-labelledby="labelId">
        <template #element>
          <div :class="classes.wrapper" role="group" >
            <slot>
              <component :is="component(element)"
                v-for="(element, name) in children"
                v-bind="element"
                :embed="embed"
                :name="name"
                :key="name"
                @remove="(e) => $emit('remove', e)"
            />
            </slot>
          </div>
        </template>

        <!-- Default element slots -->
        <template v-for="(component, slot) in elementSlots" #[slot]><slot :name="slot" :el$="el$"><component :is="component" :el$="el$"/></slot></template>
      </component>

    </div>
  </details>

</template>

<script>
import { ref, markRaw } from 'vue'
import { ObjectElement } from '@vueform/vueform'

export default {
  // Copy all properties of ObjectElement (eg. emits, mixins, ...)
  ...ObjectElement,
  name: 'AccordionElement',
  props: {
    // Copy props from ObjectElement
    ...ObjectElement.props,
  },
  setup(props, context) {
    // Copy all props / methods from ObjectElement
    const AccordionElement = ObjectElement.setup(props, context)

    // ObjectElement's classes from Tailwind Theme's source
    // https://github.com/vueform/vueform/blob/main/themes/tailwind/classes.js#L712
    const defaultClasses = ref({
      container: '',
      wrapper: 'grid grid-cols-12',
      wrapper_sm: 'form-gap-gutter-sm',
      wrapper_md: 'form-gap-gutter',
      wrapper_lg: 'form-gap-gutter-lg',
      wrapper_embed: '!block',
      $wrapper: (classes, { Size, embed }) => ([
        classes.wrapper,
        classes[`wrapper_${Size}`],
        embed ? classes.wrapper_embed : null,
      ]),
    })

    return {
      ...AccordionElement,
      defaultClasses,
      template,
    }
  },
}
</script>